<template>
  <detail-section title="Property">
    <div class="d-flex flex-row align-items-start gap-2">
      <div class="d-flex flex-column gap-1 min-w-0 flex-grow-1">
        <div class="license-address text-truncate">
          {{ snapshotAddress }}
        </div>
        <AssessorLink :property="property" class="text-muted small" />
      </div>
    </div>
  </detail-section>
</template>

<script>
import DetailSection from "@/components/common/DetailSection.vue";
import AssessorLink from "@/components/common/AssessorLink.vue";
import {normalizeAddressLines} from "@/addressFormatting";
import {Property} from "@/models/Property";

export default {
  components: {AssessorLink, DetailSection},
  props: {
    property: Property
  },
  data() {
    return {};
  },
  computed: {
    snapshotAddress() {
      const rawAddress = this.property?.addressFormatted || this.property?.unverifiedAddress;
      const [line1] = normalizeAddressLines(rawAddress);
      return line1 || rawAddress || 'Unknown address';
    }
  }
}
</script>

<style scoped>
.license-address {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.25;
}
</style>
